import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import VueFormat from 'vue-format'
import VueClipboard from 'vue-clipboard2'
// import {
// 	Vuetify,
// 	VApp,
// 	VAlert, VBottomNav, VCard, VDialog,
// 	VNavigationDrawer, VFooter,
// 	VList, VBtn, VMenu, VIcon, VGrid,
// 	VToolbar, VTooltip, VTextField,
// 	VDataTable, VPagination,
// 	transitions
// } from 'vuetify'


// import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

//import '@mdi/font'
//import '@mdi/js'

import router from './router/index'
import store from './store/index'

import MainAppBarComponent from
		'./components/app/MainBarComponent'
import MainNavigationDrawerComponent from
		'./components/app/MainNavigationDrawerComponent'

import UserCardComponent from "./components/auth/UserCardComponent"
import NotesEditorComponent from "./components/NotesEditorComponent"
import Plate96Component from "./components/plate/Plate96Component"
import WellOfPlateComponent from "./components/plate/WellOfPlateComponent"
import LineExample from "vue-chartjs/src/examples/LineExample"
import format from "string-format"

Vue.component('main-bar', MainAppBarComponent)
Vue.component('main-navigation-drawer', MainNavigationDrawerComponent)

Vue.component('notes-editor', NotesEditorComponent)
Vue.component('user-card', UserCardComponent)
// Vue.component('line-example', LineExample)


Vue.config.productionTip = false

// Vue.config.errorHandler = function (error) {
//
// 	let error_msg = "<ERROR>"
//
// 	if (error.isAxiosError) {
// 		error_msg = format(
// 			"<pre>url: {baseURL}/{url}, method: <b>{method}</b>\n{error}</pre>", {
// 				baseURL: error.config.baseURL, url: error.config.url,
// 				method: error.config.method, error: error.toString()
// 			})
// 	} else {
// 		error_msg = error.toString()
// 	}
//
// 	store.dispatch('message/add', {
// 		type: 'error',
// 		html: error_msg
// 	})
//
// 	let k = 5
// 	throw error
// }

Vue.use(Vuex)
Vue.use(VueFormat)
Vue.use(VueClipboard)

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount('#app')


